import helper from "@/config/helper";
import Moment from "moment";
import Vue from "vue";

const toastrOptions = {
	position: "top",
};

const state = {
	paymentMethods:		"",

	forma_pagamento:	null,
	cardKey:			null,
	cc_holder:			"",
	cc_number:			"",
	cc_cvv:				"",
	cc_exp_month:		"",
	cc_exp_year:		"",

	removeCardIndex:	null,
}

const isStateValid = (state) => {
	if(state.forma_pagamento == null || state.forma_pagamento == ""){
		Vue.$toast.info("Selecione uma forma de pagamento", toastrOptions);
		return false;
	}

	if(state.forma_pagamento == "CC"){
		if(state.cc_holder.trim().length <= 4){
			Vue.$toast.warning("Nome do titular do cartão inválido!", toastrOptions);
			return false;
		}

		if(state.cc_number.trim().length < 13){
			Vue.$toast.warning("Preencha o número do cartão!", toastrOptions);
			return false;
		}

		if(state.cc_cvv.trim().length < 3){
			Vue.$toast.warning("CVV inválido!", toastrOptions);
			return false;
		}

		if(state.cc_exp_month == "" || state.cc_exp_month == null){
			Vue.$toast.warning("Selecione o mês de validade do cartão!", toastrOptions);
			return false;
		}

		if(state.cc_exp_year == "" || state.cc_exp_year == null){
			Vue.$toast.warning("Selecione o ano de validade do cartão!", toastrOptions);
			return false;
		}

		let mes = Moment().month() + 1;
		let year = Moment().year();

		// verifica se o cartão está vencido
		if(state.cc_exp_month < mes && state.cc_exp_year <= year){
			Vue.$toast.warning("Data de validade inválida!", toastrOptions);
			return false;
		}
	}

	return true;
}

const actions = {
	addCard({ commit, dispatch, state, rootState, rootGetters }){
		if(!isStateValid(state)){
			return;
		}

		commit("setLoading", true, { root: true });

		const credentials = rootGetters['auth/getCredentials'];

		var data = new FormData();
		data.append("email",			credentials.email);
		data.append("code",				credentials.code);
		data.append("token",			credentials.token);
		data.append("merchant_number",	rootState.subscriptionDetail.merchant_number);
		data.append("subscription_id",	rootState.subscriptionDetail.subscription_id);
		data.append("customer_taxid",	rootState.subscriptionDetail.customer_taxid);
		data.append("method",			"addCard");

		data.append("forma_pagamento",	state.forma_pagamento);
		data.append("cc_holder",		state.cc_holder);
		data.append("cc_number",		state.cc_number);
		data.append("cc_cvv",			state.cc_cvv);
		data.append("cc_exp_month",		state.cc_exp_month);
		data.append("cc_exp_year",		state.cc_exp_year);

		helper
			.axios()
			.post("", data)
			.then(() => {
				dispatch("subscriptionDetail/getSubscription", null, { root: true });
				dispatch("analytics/setFeedback", "add_card", { root: true });
				commit("modals/setDialogAddCard", false, { root: true });
				commit("modals/setDialogCharge", false, { root: true });
				commit("clearForm");
				Vue.$toast.success("Cartão adicionado com sucesso.", toastrOptions);
			})
			.catch((error) => {
				helper.callback_error(error, "Falha ao adicionar o cartão.");
			})
			.finally(() => {
				commit("setLoading", false, { root: true });
			});
	},

	changeCard({ commit, dispatch, rootState, rootGetters }, key){
		let prevSaved = 0;

		if(key != null){
			prevSaved = rootState.subscriptionDetail.available_cards[key].cc_token;
		}

		commit("setLoading", true, { root: true });

		const credentials = rootGetters['auth/getCredentials'];

		var data = new FormData();
		data.append("email",			credentials.email);
		data.append("code",				credentials.code);
		data.append("token",			credentials.token);
		data.append("merchant_number",	rootState.subscriptionDetail.merchant_number);
		data.append("subscription_id",	rootState.subscriptionDetail.subscription_id);
		data.append("method",			"changeCard");
		data.append("cc_prevsaved",		prevSaved);

		helper
			.axios()
			.post("", data)
			.then(() => {
				dispatch("subscriptionDetail/getSubscription", null, { root: true });
				dispatch("analytics/setFeedback", "change_payment_method", { root: true });
				Vue.$toast.success("Forma de pagamento alterada com sucesso.", toastrOptions);
			})
			.catch((error) => {
				helper.callback_error(error, "Falha ao trocar a preferência de pagamento.");
			})
			.finally(() => {
				commit("setLoading", false, { root: true });
				commit("modals/setDialogPaymentMethod", false, { root: true });
				commit("modals/setDialogCharge", false, { root: true });
			});
	},

	removeCard({ commit, dispatch, state, rootState, rootGetters }){
		commit("setLoading", true, { root: true });

		let prevSaved	= null;
		let taxid		= null;

		if(state.removeCardIndex != null){
			prevSaved	= rootState.subscriptionDetail.available_cards[state.removeCardIndex].cc_token;
			taxid		= rootState.subscriptionDetail.available_cards[state.removeCardIndex].taxid;
		}

		const credentials = rootGetters['auth/getCredentials'];

		var data = new FormData();
		data.append("email",			credentials.email);
		data.append("code",				credentials.code);
		data.append("token",			credentials.token);
		data.append("merchant_number",	rootState.subscriptionDetail.merchant_number);
		data.append("subscription_id",	rootState.subscriptionDetail.subscription_id);
		data.append("method",			"removeCard");

		data.append("cc_prevsaved",		prevSaved);
		data.append("taxid",			taxid);

		helper
			.axios()
			.post("", data)
			.then(() => {
				commit("modals/setDialogPaymentMethod", false, { root: true });
				commit("modals/setDialogRemoveCardConfirmation", false, { root: true });
				dispatch("subscriptionDetail/getSubscription", null, { root: true });
				Vue.$toast.success("Cartão removido com sucesso.", toastrOptions);
			})
			.catch((error) => {
				helper.callback_error(error, "Falha ao remover o cartão.");
			})
			.finally(() => {
				commit("setLoading", false, { root: true });
				commit("modals/setDialogPaymentMethod", false, { root: true });
			});
	},
}

const mutations = {
	setPaymentMethods(state, content){
		state.paymentMethods = content;
	},

	setFormaPagamento(state, content){
		state.forma_pagamento = content;
	},

	setCardKey(state, content) {
		state.cardKey = content;
	},

	setCCHolder(state, content){
		state.cc_holder = content;
	},

	setCCNumber(state, content){
		state.cc_number = content;
	},

	setCCCvv(state, content){
		state.cc_cvv = content;
	},

	setCCExp_month(state, content){
		state.cc_exp_month = content;
	},

	setCCExp_year(state, content){
		state.cc_exp_year = content;
	},

	setRemoveCardIndex(state, content){
		state.removeCardIndex = content;
	},

	clearForm(state){
		state.cc_holder		= "";
		state.cc_number		= "";
		state.cc_exp_month	= "";
		state.cc_exp_year	= "";
		state.cc_cvv		= "";
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
};
